import { Component } from 'react';
import { Avatar, Button, Layout, Menu, Modal, Space, Spin } from 'antd';
import {
  LoadingOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { history } from '../../utils/history';
import CustomRouter from '../../components/Routing/CustomRouter.jsx';
import { checkUserLogin, login, logout } from '../../actions/AuthActions';
import './BasicLayout.less';
import { getCurrentUserAction } from '../../actions/UserActions';
import UserContext from './UserContext';
import LoginPage from '../login/LoginPage';
import FbqPolicyPage from '../policy/fbq';
import ExploremaltaPolicyPage from '../policy/exploremalta';
import { getUsernameAvatar } from '../../utils/userAvatars';
import checkEnabledFeatures, { FEATURES } from '../../components/Authorization/Feature';
import NotFound from '../../components/NotFound';
import FullTextSearch from './Search.js';
import SiderMenu from './SiderMenu.js';
import LangSelector from './LangSelector.js';

const { Header, Sider, Content, Footer } = Layout;

const getAvatar = currentUser => {
  if (!currentUser) return '';
  if (!currentUser.avatarUrl)
    return getUsernameAvatar(currentUser.username, 'normal');
  return <Avatar src={currentUser ? currentUser.avatarUrl : ''} />;
};

class BasicLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      smallIcon: false,
      isSearchModalVisible: false
    };
  }

  async componentDidMount() {
    const { checkUserLogin: checkUserLogin1 } = this.props;
    await checkUserLogin1();
    const { getCurrentUserAction: getCurrentUserAction1 } = this.props;
    await getCurrentUserAction1();
  }

  showSearchModal = () => {
    this.setState({
      isSearchModalVisible: true,
    });
  };

  handleOkSearchModal = e => {
    this.setState({
      isSearchModalVisible: false,
    });
  };

  handleCancelSearchModal = e => {
    this.setState({
      isSearchModalVisible: false,
    });
  };


  handleOnCollapse = () => {
    this.setState(
      {
        collapsed: !this.state.collapsed,
      },
      () => {
        setTimeout(
          () =>
            this.setState({
              smallIcon: !this.state.smallIcon,
            }),
          150,
        );
      },
    );
  };

  handleSettingMenuClick = e => {
    if (e.key === 'setting:1') {
      history.push('/profile');
    } else if (e.key === 'setting:2') {
      const { props } = this;
      props.logout();
    }
  };

  handleLogout = () => {
    const { logout: logout1 } = this.props;
    logout1();
  };

  render() {
    const pathName = window.location.pathname.replace(/\//g, '');
    const { collapsed } = this.state;
    const { loggingIn, loggedIn } = this.props;

    const tenant = window.location.hostname.split('.')[0];
    if (pathName === 'policy') {
      switch (tenant) {
        case 'fbq':
          return <FbqPolicyPage />;
        case 'exploremalta':
          return <ExploremaltaPolicyPage />;
        default:
          return <NotFound />;
      }
    }

    if (!loggedIn && loggingIn === false) {
      return <LoginPage />;
    } if (loggingIn === true) {
      return (
        <div
          style={{
            height: '100vh',
            width: '100%',
            backgroundColor: 'white',
            textAlign: 'center',
            position: 'absolute',
          }}
        >
          <Spin
            style={{ top: '50%', position: 'absolute' }}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          />
        </div>
      );
    } else {
      const { currentUser } = this.props;
      const { smallIcon } = this.state;
      return (
        (<UserContext.Provider
          value={currentUser}
        >
          <Layout style={{ minHeight: '100vh' }}>

            <Sider
              breakpoint="lg"
              collapsedWidth="80"
              onCollapse={this.handleOnCollapse}
              collapsed={collapsed}
              width="256"
              theme="light"
            >
              <a
                onClick={() => {
                  history.push('/');
                }}
              >
                <div
                  className={
                    collapsed && smallIcon ? 'menu-logo-collapsed' : 'menu-logo'
                  }
                />
              </a>
              <SiderMenu />
            </Sider>
            <Layout>

              <Header
                className="header"
                style={{ background: '#fff', padding: 0 }}
              >
                <div
                  style={{
                    float: 'left',
                    width: '100%',
                    alignSelf: 'center',
                    display: 'flex',
                  }}
                >
                  {window.innerWidth > 992 &&
                    (collapsed ? (
                      <MenuUnfoldOutlined
                        style={{
                          marginLeft: 16,
                          marginRight: 16,
                          alignSelf: 'center',
                        }}
                        className="trigger"
                        onClick={() => this.handleOnCollapse()}
                      />
                    ) : (
                      <MenuFoldOutlined
                        style={{
                          marginLeft: 16,
                          marginRight: 16,
                          alignSelf: 'center',
                        }}
                        className="trigger"
                        onClick={() => this.handleOnCollapse()}
                      />
                    ))}
                </div>

                <Space>

                  {checkEnabledFeatures(currentUser, FEATURES.GLOBAL_SEARCH) && (
                    <div>
                      <Button shape="circle" icon={<SearchOutlined />} onClick={this.showSearchModal} />
                    </div>
                  )}

                  {checkEnabledFeatures(currentUser, FEATURES.MULTI_LANGUAGE) && (
                    <div>
                      <LangSelector />
                    </div>
                  )}

                  <Menu
                    onClick={this.handleSettingMenuClick}
                    mode="horizontal"
                    items={[
                      {
                        key: 'extra',
                        label: getAvatar(currentUser),
                        children: [
                          {
                            key: 'setting:1',
                            label: (
                              <Space>
                                <UserOutlined />
                                {this.props.t('layout.profile')}
                              </Space>
                            ),
                          },
                          {
                            key: 'setting:2',
                            label: (
                              <Space>
                                <LogoutOutlined onClick={() => this.handleLogout()} />
                                {this.props.t('layout.logout')}
                              </Space>
                            ),
                          },
                        ],
                      },
                    ]}
                  />
                </Space>


              </Header>
              <Content>
                <Modal
                  title={this.props.t('layout.globalSearch')}
                  open={this.state.isSearchModalVisible}
                  onOk={this.handleOkSearchModal}
                  onCancel={this.handleCancelSearchModal}
                  width={920}
                  destroyOnHidden={true}
                  footer={null}
                >
                  <FullTextSearch closeModal={this.handleCancelSearchModal} />
                  <p></p>
                </Modal>
                <CustomRouter currentUser={currentUser} />

              </Content>
              <Footer style={{ textAlign: 'center' }}>
                {this.props.t('layout.footer', { year: new Date().getFullYear() })}

              </Footer>
            </Layout>

          </Layout>
        </UserContext.Provider>)
      );
    }
  }
}

BasicLayout.propTypes = {
  loggingIn: PropTypes.bool,
  loggedIn: PropTypes.bool,
  checkUserLogin: PropTypes.func,
  logout: PropTypes.func,
  location: PropTypes.object,
  currentUser: PropTypes.object,
  getCurrentUserAction: PropTypes.func,
};

function mapStateToProps({ auth, userReducer }) {
  const { loggedIn, loggingIn } = auth;
  const { currentUser } = userReducer;
  return { loggedIn, loggingIn, currentUser };
}

export default connect(mapStateToProps, {
  checkUserLogin,
  login,
  logout,
  getCurrentUserAction,
})(withTranslation()(BasicLayout));
